/**
 * Pure math behind the animated peon "looking at" a focused form field
 * (src/components/LivePeon.tsx): given the mascot's centre and the focused
 * element's centre, which of the sprite sheet's four off-centre eye cells to
 * show. Kept separate from the component so the geometry can be unit tested
 * without a DOM.
 */

/** The sheet's off-centre eye cells (see public/ui/peon-sheet.json); "center" and "blink" are handled elsewhere. */
export type GazeDirection = "left" | "right" | "downLeft" | "downRight";

export interface Point {
  x: number;
  y: number;
}

/**
 * The vector from the peon's centre to the target's centre decides the
 * direction: mostly-below (dy bigger than half the sideways distance) looks
 * down-left or down-right by the sign of dx, anything else looks left or
 * right. A field dead centre below (dx === 0) reads as down-right, and one
 * dead level (dy === 0) reads as right; both are arbitrary but deterministic.
 */
export function chooseGazeDirection(from: Point, to: Point): GazeDirection {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  if (dy > Math.abs(dx) * 0.5) {
    return dx < 0 ? "downLeft" : "downRight";
  }
  return dx < 0 ? "left" : "right";
}
